import {getDateStr} from './UI.js';

export default class Validate {
    constructor(form) {
        this.form = $(form);
        //this.inputs = this.form.find('input, select, textarea');
        this.inputs = this.form.find('input, select, textarea').filter(':not(.template-field)');
        this.required = this.form.find('[data-required]');
        this.recaptcha = this.form.find('.js-recaptcha');
        this.email = this.form.find('[data-email]');
        this.minlength = this.form.find('[data-minlength]');
        this.fileformat = this.form.find('[data-fileformat]');
        this.submitBtn = this.form.find('[data-submit]');
        this.messages = window.validateMessages || {
            required: 'Не заполнено поле',
            minlength: 'Не менее %min% символов',
            email: 'Неправильный формат',
            fileformat: 'Недопустимый тип файла',
            filesize: 'Файл должен быть до %max% МБ'
        };

        /**
            Так как могут быть поля обязательные,
            но ещё не проверенные, приходится вводить
            для них дополнительный класс
        */
        this.form.find('[data-required]').not(':checkbox').addClass('_notvalidated');
        //this.form.find('[data-required]').not(':checkbox').not('._no-empty').addClass('_notvalidated');

        // для обязательных чекбоксов только те, что не отмечены по умолчанию
        this.form.find(':checkbox[data-required]').not(':checked').addClass('_notvalidated');

        // для полей даты типа "от" и "до"
        this.dateRangePrepare();

        this.handleChange();
    }

    dateRangePrepare() {
        //this.inputs.filter('[data-date-from]').each(function (index, el) {
        $('[data-date-from]:not(.template-field)').each(function (index, el) {
            $(el).attr('data-from-index', index + 1).data('from-index', index + 1);
            $(el).closest('.js-input-wrap').next().find('.js-input').attr('data-to-index', index + 1).data('to-index', index + 1);
        });
    }

    handleChange() {
        const eventName = App.ie ? 'change blur' : 'change';

        this.inputs.on(eventName, e => {
            const $input = $(e.target);
            this.validateField($input);

            // Считаем ошибки
            this.calculateErrors();
        });
    }

    // Проверить все ошибки формы
    validateAllFields() {
        this.inputs.each((index, el) => {
            let $currInput = $(el);

            this.validateField($currInput);
        });

        /* Если каптча не пройдена, то показываем ошибку */
        if (this.recaptcha.hasClass('_notvalidated')) {
            this.recaptcha.addClass('_error');
        }

        return this.returnErrorsCount() === 0;
    }

    validatePass($input) {
        let $passInputs = $input.closest('.js-form').find('[data-pass]');
        let pass1 = $passInputs.eq(0).val();
        let pass2 = $passInputs.eq(1).val();

        $passInputs.removeClass('_error');

        if (pass1.length > 0 && pass2.length > 0
            && ($passInputs.eq(0).data('minlength') && pass1.length >= parseInt($passInputs.eq(0).data('minlength')))
            && pass1 === pass2) {
            $passInputs.removeClass('_error');
        } else if (pass1 !== pass2) {
            $passInputs.eq(1).addClass('_error');
        } else {
            $passInputs.eq(0).addClass('_error');
        }
    }

    validateField($input) {
        // Запускаем проверки
        // Если поле телефона с маской, то не проверяем его, оно проверятется в Mask.js
        if ($input.is('.js-mask-phone') && $input.val().length > 0) {
            if ($input.is('._filled') && $input.val().length > 0) {
                $input.removeClass('_notvalidated');
            }
            return false;
        }

        if ($input.is(':checkbox[data-required]')) {
            this.validateRequiredCheckbox($input);
        } else if ($input.is('[data-required]')) {
            this.validateRequired($input);
        }

        if ($input.is('[data-minlength]')) {
            this.validateMinLength($input);
        }

        if ($input.is('[data-pass]')) {
            this.validatePass($input);
        }

        if ($input.is('[type=email]') || $input.is('[data-email]')) {
            this.validateEmail($input);
        }

        if ($input.is('[data-fileformat]')) {
            this.validateFileFormat($input);
        }

        if ($input.is('[data-required-group]')) {
            this.validateRequiredGroup($input);
        }

        //if ($input.is('[data-date]')) {
        if ($input.is('[data-date]') && $input.val() !== '') {
            this.validateDateField($input);
        }

        /*if ( $input.is('[data-filesize]') ) {
            this.validateFileSize($input);
        }*/

        /*if ($input.is('._filled')) {
            $input.removeClass('_error');
        }*/


        /**
         Теперь поле либо валидно, либо у него
         есть класс _error, и ложной разблокировки
         кнопки сабмита не будет
         */
        $input.removeClass('_notvalidated');
    }

    validateRequired($input) {
        // Проверяем обязательные поля

        const $label = $input.closest('.js-input-wrap').find('[data-label]');
        // поле ввода телефона intlTelInput
        const $iti = $input.closest('.js-input-wrap').find('.iti');
        //const val = $input.val().replace(/\s/g, '');
        const val = $input.val() === null ? '' : $input.val().replace(/\s/g, '');

        //if ($input.is('[data-dadata]') && val.length > 0) {
        //if ($input.is('[data-dadata]') && !$input.hasClass('dadata-valid')) {
        if ($input.is('[data-dadata]') && $input.hasClass('dadata-invalid') && !$input.hasClass('_filled')) {
            $input.addClass('_error');
            $label.text($label.text().length > 0 ? $label.text() : this.messages.required);
            return false;
        }

        /**
         Убираем или подставляем класс _error,
         а также текст об ошибке
         */
        //if (val.length > 0) {
        //|| $input.hasClass('js-mask-phone')
        if (val.length > 0 || $input.hasClass('_filled')) {
            $input.removeClass('_error');
            $iti.removeClass('_error');
            //$label.text('');
        } else {
            $input.addClass('_error');
            $iti.addClass('_error');
            //$label.text(this.messages.required);
            $label.text($label.text().length > 0 ? $label.text() : this.messages.required);
        }
    }


    validateRequiredCheckbox($input) {
        // Проверяем обязательные чекбоксы
        const $label = $input.parent().siblings('[data-label]');

        if ($input.is(':checked')) {
            $input.removeClass('_error');
            //$label.text('');
        } else {
            $input.addClass('_error');
            //$label.text(this.messages.required);
            $label.text($label.text().length > 0 ? $label.text() : this.messages.required);
        }
    }

    validateRequiredGroup($input) {
        /**
         Проверяем группу чекбоксов, где хотя бы один
         должен быть отмечен
         */
        const $group = this.form.find(`[name="${$input.attr('name')}"]`);
        const $label = $input.siblings('[data-label]') || $input.closest('.js-input-wrap').find('[data-label]');
        let checked = 0;
        /*let _index = 0;*/

        $group.each(function(index, el) {
            if ( $(el).is(':checked') ) {
                checked++;
            }

            /*if ($group.hasClass('_input-for-error')) {
                _index = index;
            }*/

            $(el).removeClass('_notvalidated');
        });



        /**
         На всю группу нужен только один маркер _error,
         поэтому добавляем его только первому элементу
         */
        if (checked > 0) {
            //$group.eq(0).removeClass('_error');

            //$group.eq(_index).removeClass('_error');
            $group.removeClass('_error');

            //$label.text('');
        } else {
            //$group.eq(0).addClass('_error');

            //$group.eq(_index).addClass('_error');
            $group.addClass('_error');

            //$label.text(this.messages.required);
            $label.text($label.text().length > 0 ? $label.text() : this.messages.required);
        }
    }


    validateMinLength($input) {
        // Проверяем минимальное количество символов

        const $label = $input.siblings('[data-label]');
        const min = $input.data('minlength');
        const val = $.trim($input.val());

        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        if (val.length >= min) {
            // Достаточно символов

            $input.removeClass('_error');
            //$label.text('');

        } else if (val.length > 0) {
            // Недостаточно символов

            const message = this.messages.minlength.replace('%min%', min);

            $input.addClass('_error');
            $label.text(message);
        } else if (val.length == 0 && $input.is(':not([data-required])')) {
            // Поле пустое и необязательное

            /**
                Если оно обязательное, в этом случае за него
                будет отвечать validateRequired()
            */

            $input.removeClass('_error');
            //$label.text('');
        }
    }


    validateEmail($input) {
        // Проверяем email

        const $label = $input.siblings('[data-label]');
        const val = $input.val().replace(/\s/g, '');

        /**
            Если поле пустое, то не валидируем его,
            оставляем эту работу для validateRequired()
        */

        if (!val.length) return;
        /*if (!val.length && (!$input.is('[data-required]') || $input.is('._filled'))) {
            $input.removeClass('_error');
            return;
        }*/


        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        if (/^[a-z0-9](\.?[a-z0-9_-]){0,}@[a-z0-9-]+\.([a-z]{1,20}\.)?[a-z]{2,6}$/i.test(val)) {
            $input.removeClass('_error');
            //$label.text('');
        } else {
            $input.addClass('_error');
            //$label.text(this.messages.email);
            $label.text($label.text().length > 0 ? $label.text() : this.messages.email);
        }
    }


    validateFileFormat($input) {
        // Проверяем расширение файла

        const $label = $input.siblings('[data-label]');
        const accept = $input.attr('accept').split(',');
        const val = $input.val();

        /**
            Если поле пустое, то не валидируем его,
            оставляем эту работу для validateRequired()
        */

        if (!val.length && $input.is('[data-required]')) {
            return;
        } else if (!val.length) {
            $input.removeClass('_error');
            //$label.text('');
            return;
        }


        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        let ext = '.' + val.split('.').pop();
        ext = ext.toLowerCase();

        if ($.inArray(ext, accept) > -1) {
            $input.removeClass('_error');
            //$label.text('');

            /**
                Если формат файла ОК, после этого
                проверяем размер файла
            */
            if ($input.is('[data-filesize]')) {
                this.validateFileSize($input);
            }

        } else {
            $input.addClass('_error');
            //$label.text(this.messages.fileformat);
            $label.text($label.text().length > 0 ? $label.text() : this.messages.fileformat);
        }
    }


    validateFileSize($input) {
        // Проверяем размер загруженного файла

        const $label = $input.siblings('[data-label]');
        const max = +$input.data('filesize');


        if ($input[0].files.length) {
            const size = $input[0].files[0].size / 1024 / 1024;

            if (size > max) {
                const message = this.messages.filesize.replace('%max%', max);
                $input.addClass('_error');
                $label.text(message);
            }
        }
    }

    validateDateTodayField($input) {
        if ($input.is('[data-until-today]')) {
            const $label = $input.siblings('[data-label]');
            const fromDate = new Date(getDateStr($input.val()));
            const toDate = new Date();

            if (fromDate > toDate) {
                $input.addClass('_error');
                $label.text($label.text() ? $label.text() : this.messages.daterange);
            } else {
                $input.removeClass('_error');
                $label.text('');
            }
        }

    }

    validateDateRangeField($input) {
        let isRangeDate = $input.data('from-index') || $input.data('to-index');
        let $inputFrom;
        let $inputTo;
        let $label;

        if ($input.data('from-index')) {
            let index = $input.data('from-index');
            $inputFrom = $input;
            $inputTo = $('.js-input').filter(`[data-to-index="${index}"]`);
        }

        if ($input.data('to-index')) {
            let index = $input.data('to-index');
            $inputFrom = $('.js-input').filter(`[data-from-index="${index}"]`);
            $inputTo = $input;
        }

        if (isRangeDate) {
            $label = $inputFrom.closest('.js-input-wrap').find('[data-label]');
            let fromDate = new Date(getDateStr($inputFrom.val()));
            let toDate = new Date(getDateStr($inputTo.val()));

            if (fromDate > toDate) {
                $inputFrom.addClass('_error');
                $label.text(this.messages.daterange);
            } else {
                $inputFrom.removeClass('_error');
                $label.text('');
            }
        }
    }

    validateDateField($input) {
        const $label = $input.closest('.js-input-wrap').find('[data-label]');

        let newDateVal = getDateStr($input.val()); // дата в формате 2014/12/31

        if (isNaN(Date.parse(newDateVal))) {
            $label.text($label.text().length > 0 ? $label.text() : this.messages.required);
            $input.addClass('_error');
        } else {
            $input.removeClass('_error');
            this.validateDateRangeField($input);
            this.validateDateTodayField($input);
        }
    }

    returnErrorsCount() {
        return this.form.find('._error, ._notvalidated').length;
        //return this.form.find('._error').length;
    }

    calculateErrors() {
        // Подводим итоги проверок

        //const errors = this.form.find('._error, ._notvalidated').length;
        const errors = this.returnErrorsCount();

        /**
            Считаем ошибки в форме,
            и блокируем или разблокируем
            кнопку сабмита
        */

        if (errors > 0) {
            this.submitBtn.attr('disabled', true);
        } else {
            this.submitBtn.removeAttr('disabled');
        }
    }
}
